import { refreshToken } from "./authentication/RefreshTokenAPI";

function prepareAPICall() {
    refreshToken();
    return "https://api.trendz.vn/";
}

const StatisticsURL = prepareAPICall();
const NewsSpecsURL = "https://news.trendz.vn/";
const AuthenticationURL = "https://authy.trendz.vn/";
const FeedbackServiceURL = "https://reports.trendz.vn/";
const SocketURL = "http://192.168.1.200:8080";

export {
  StatisticsURL,
  NewsSpecsURL,
  AuthenticationURL,
  FeedbackServiceURL,
  SocketURL,
};
